var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMale(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.97721 13.9993C3.7045 13.9993 2.43179 13.5221 1.45453 12.5448C0.522719 11.613 0 10.363 0 9.02213C0 7.68124 0.522719 6.45398 1.45453 5.49945C2.38633 4.56764 3.63632 4.04492 4.97721 4.04492C6.29537 4.04492 7.54536 4.56764 8.49989 5.49945C9.4317 6.43125 9.95442 7.68124 9.95442 9.02213C9.95442 10.363 9.4317 11.5903 8.49989 12.5448C7.52263 13.4993 6.24992 13.9993 4.97721 13.9993ZM4.97721 5.40854C4.02268 5.40854 3.1136 5.7949 2.43179 6.45398C1.74998 7.13579 1.38634 8.04487 1.38634 8.9994C1.38634 9.95394 1.7727 10.863 2.43179 11.5448C3.1136 12.2266 4.02268 12.5903 4.97721 12.5903C5.93174 12.5903 6.84082 12.2266 7.52263 11.5448C8.20444 10.863 8.56807 9.95394 8.56807 8.9994C8.56807 8.04487 8.18171 7.13579 7.52263 6.45398C6.84082 5.7949 5.93174 5.40854 4.97721 5.40854Z",
    fill: "#7D74FC"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.00017 6.68103C7.81835 6.68103 7.65926 6.61285 7.5229 6.47649C7.25018 6.20377 7.25018 5.77195 7.5229 5.52196L12.1138 0.931105C12.3865 0.658382 12.8183 0.658382 13.0683 0.931105C13.341 1.20383 13.341 1.63564 13.0683 1.88564L8.47744 6.47649C8.3638 6.61285 8.18199 6.68103 8.00017 6.68103Z",
    fill: "#7D74FC"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.3179 4.22722C12.9315 4.22722 12.6361 3.93177 12.6361 3.54541V1.36362H10.4543C10.0679 1.36362 9.77246 1.06817 9.77246 0.68181C9.77246 0.295451 10.0679 0 10.4543 0H13.3179C13.7042 0 13.9997 0.295451 13.9997 0.68181V3.54541C13.9997 3.90904 13.6815 4.22722 13.3179 4.22722Z",
    fill: "#7D74FC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMale);
export default __webpack_public_path__ + "static/media/male.c9559c2e.svg";
export { ForwardRef as ReactComponent };